import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './component/table/table.component';
import { IconModule } from '../icon/icon.module';
import { SelectModule } from '../select/select.module';
import { DpDatePickerModule } from 'ng2-date-picker';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SafeHtmlPipe } from 'src/app/shared/pipes/safeHTML/safe-html.pipe';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {SplitButtonModule} from '../../shared/components/split-button/split-button.module';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
  declarations: [TableComponent, SafeHtmlPipe],
    imports: [
        TranslatePipe, TranslateDirective,
        MatTooltipModule,
        CommonModule,
        IconModule,
        SelectModule,
        DpDatePickerModule,
        FormsModule,
        MatChipsModule,
        MatIconModule,
        SplitButtonModule,
        MatMenuModule,
        MatButtonModule,
    ],
  exports: [TableComponent]
})
export class TableModule { }
